import ko from 'knockout';
import _ from 'underscore';
import Backbone from 'backbone';
import Promise from 'bluebird';
import DataStore from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import withUIBlocker from '@bingads-webui-component-legacy/uiblocker/index';
import ViewModel from '@bingads-webui-campaign-legacy/auto-targets/viewmodel/pagefeed/targeting-source';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/pagefeed/targeting-source.pug';
import '@bingads-webui-component-legacy/double-list-box/ko/doubleListBoxBinding';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class TargetingSource extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.koModel = new ViewModel(_.defaults({}, options, {
      loadSource: this.loadSource.bind(this),
    }));

    this.koModel.targetingSource.subscribe((val) => {
      this.logActivity(`target source changed: ${val.source}`);
      this.trigger('update', val);
    });

    this.on('set', ({source, campaignId}) => { // interface for copy from campaign
      this.koModel.source(source);
      this.koModel.campaignId(campaignId);
    });
  }

  logActivity(message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, 'target source');
    }
  }

  render() {
    this.$el.html(template({ i18n }));
    ko.applyBindings(this.koModel, this.el);
    return this;
  }

  validate() {
    return _.size(this.koModel.errors()) === 0;
  }

  loadSource(request, cb) {
    const params = {  //eslint-disable-line
      where: {
        Name: {
          $contains: request.filterText,
        },
        FeedCategoryFilter: {
          $eq: 'Enum.FeedCategory\'PageFeed\'',
        },
        Status: {
          $eq: 'Enum.FeedStatus\'Active\'',
        },
      },
      offset: request.skip,
      limit: request.take,
    };

    DataStore.Feed.findAll(params, {
      entitySet: edmCampaign.currentAccount.Feeds,
      cacheResponse: false,
      'x-ms-refreshcampaigncache': 'true',
      filterOptions: {
        odata: {
          custom: {
            FeedCategoryFilter: () => 'FeedCategories/any(c:c eq Enum.FeedCategory\'PageFeed\')',
          },
        },
      },
    }).then((items) => cb(null, {
      items: _.map(items, (item) => ({ Id: item.Id, Name: item.Name })),
      total: items.totalCount,
    })).finally(withUIBlocker(this.$el));
  }

  save(id) {
    const EntityId = String(id);

    if (this.koModel.source() === 'SystemIndex') {
      return Promise.resolve();
    }
    const disAssociateList = _.difference(this.koModel.originSelectedIdList(), this.koModel.selectedIdList());
    const associateList = _.difference(this.koModel.selectedIdList(), this.koModel.originSelectedIdList());
    let requests = _.map(associateList, (FeedId) => ({ '@odata.type': '#Model.FeedAssociation', FeedId, EntityId, AssociationType: 'Campaign', Status: 'Active' }));

    requests = requests.concat(_.map(disAssociateList, (FeedId) => ({ '@odata.type': '#Model.FeedAssociation', FeedId, EntityId, AssociationType: 'Campaign', Status: 'Deleted' })));
    if (_.size(requests) === 0) {
      return Promise.resolve();
    }
    return DataStore.FeedAssociation.create({
      Associations: requests,
    }, {
      cacheResponse: false,
      'x-ms-refreshcampaigncache': 'true',
      cast: 'Default.Associate',
    }).then((data) => {
      instrumentation.logMessage(
        [constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,
        'CreateFeedAssociation',
        '1'
      );
      this.logActivity('feed association created');
      return data;
    }).then(() => {
      return this.koModel.updateSelectedFeedsByCampaignId(id, true);
    }).catch((e) => {
      instrumentation.logMessage(
        [constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.VERBOSE,
        'CreateFeedAssociation',
        e
      );
      return null;
    });
  }
}
